import { Flex, Link, Text } from '@chakra-ui/react'
import React, { useEffect } from 'react'
import { MangoButton } from '~/components/shared/MangoButton'
import { useAnalytics } from '~/hooks/useAnalytics'
import { AnalyticsNamespace, WebPhoneAnalyticsEvents } from '~/types/Analytics'

import { useCallErrorStyle } from './componentStyles/CallError.style'

interface CallErrorViewProps {
  error: Error | null
  isMicPermissionDenied: boolean
  isConnected: boolean
  onRetryClick: () => void
}
export const CallErrorView = ({
  isMicPermissionDenied,
  onRetryClick,
  isConnected,
}: CallErrorViewProps) => {
  const { track } = useAnalytics(AnalyticsNamespace.WEB_PHONE)

  const handleRetryClick = () => {
    onRetryClick()
    track(WebPhoneAnalyticsEvents.RestartSipClientErrorClick)
  }

  useEffect(() => {
    let retryTimer: NodeJS.Timeout | null = null

    const attemptReconnect = () => {
      if (!isConnected) {
        console.log('Retrying connection...')
        handleRetryClick()
        retryTimer = setTimeout(attemptReconnect, 5000)
      }
    }

    if (!isConnected) {
      attemptReconnect()
    }

    return () => {
      if (retryTimer) {
        clearTimeout(retryTimer)
      }
    }
  }, [isConnected])
  const styles = useCallErrorStyle()
  return (
    <Flex sx={styles.container}>
      {isMicPermissionDenied ? (
        <Flex sx={styles.micBody}>
          <Text sx={{ ...styles.errorText, ...styles.h6 }}>
            Microphone permissions are disabled!
          </Text>
          <Text sx={{ ...styles.errorText, ...styles.body1 }}>
            <div>
              Enabling your microphone permission will allow use of the
              webphone.
            </div>
            <div>
              See{' '}
              <Link
                sx={styles.link}
                href="https://support.google.com/chrome/answer/2693767?hl=en&co=GENIE.Platform%3DDesktop"
                target="_blank"
                rel="noopener noreferrer"
              >
                here
              </Link>{' '}
              for help.
            </div>
          </Text>
        </Flex>
      ) : !isConnected ? (
        <>
          <Flex sx={styles.header}>
            <Text sx={styles.disconnectedTitle}>You are Disconnected</Text>
          </Flex>
          <Flex sx={styles.errorBody}>
            <Text sx={{ ...styles.errorText, ...styles.body1 }}>
              <div>
                Your connection was interrupted. Click here to retry the
                connection.
              </div>
            </Text>
            <MangoButton onClick={handleRetryClick}>Reconnect</MangoButton>
          </Flex>
        </>
      ) : null}
    </Flex>
  )
}
